import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { LoadingModule } from '../loading/loading.module';
import { ImageOrientationModule } from 'common/image-orientation/image-orientation.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { CannedMessagePanelComponent } from './canned-message-panel.component';
import { HighlightPipe } from './filters/highlight-text-only';
import { InnerTextPipe } from './filters/inner-text.pipe';
import { HierarchyDropdownModule } from 'shared/components/hierarchy-dropdown/hierarchy-dropdown.module';
import { InnerHtmlPipe } from 'shared/components/canned-message-panel/filters/inner-html.pipe';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    SvgIconModule,
    CommonModule,
    FormsModule,
    NgbModule,
    ImageOrientationModule,
    AutoSaveModule,
    LoadingModule,
    VirtualScrollerModule,
    HierarchyDropdownModule
  ],
  declarations: [
    CannedMessagePanelComponent,
    HighlightPipe,
    InnerTextPipe,
    InnerHtmlPipe
  ],
  exports: [
    CannedMessagePanelComponent
  ],
  providers: [
    InnerTextPipe,
    InnerHtmlPipe
  ]
})
export class CannedMessageModule {}
